export const COOKIE_KID = 'ds-kid'
export const COOKIE_TFF = 'ds-tff-enabled'
export const AUTH_METHOD_KEY = 'AUTH_METHOD'
export const AVTALEGIRO_TEST_KID = '6886868899'
export const PAYMENT_METHOD_AVTALEGIRO = 10

/** Raw paymentMethodText strings returned by the I2I backend. */
export enum PaymentMethodText {
  AVTALEGIRO = 'AvtaleGiro',
  PAPER_FAKTURA = 'Paper Faktura',
  FAKTURA = 'Faktura',
}

export enum AuthMethod {
  VIPPS = 'vipps-login',
  REGULAR = 'regular',
  BANKID = 'bankid',
  AGENT = 'agent',
}
